import React from "react";
import { selectMenuStates } from "../../store/reducers/menuSlice";
import { useSelector } from "react-redux";
import { getFixDepositRegister } from "../../api/getFixDepositRegister";
import { FixDepositRegister } from "../../models/fixdepositregister.model";
import { User } from "../../models/user.model";
import ModifyFixDepositModal from "../../components/humandc/modals/fixdeposit/ModifyFixDepositModal";
import RemoveFixDepositModal from "../../components/humandc/modals/fixdeposit/RemoveFixDepositModal";
import GoToUserProfile from "../../components/user/modals/GoToUserProfile";

export default function FHPMMainPage() {
    const [showModifyModal, setShowModifyModal] = React.useState<boolean>(false);
    const [showRemoveModal, setShowRemoveModal] = React.useState<boolean>(false);
    const [showStalkerModal, setShowStalkerModal] = React.useState<boolean>(false);
    
    const [selectedUser, setSelectedUser] = React.useState<User>();
    const [selectedRecord, setSelectedRecord] = React.useState<FixDepositRegister>();

    const [records, setRecords] = React.useState<FixDepositRegister[]>([]);
    const [recordsStateChange, setRecordsStateChange] = React.useState<boolean>(false);

    const menu = useSelector(selectMenuStates);

    const openModifyModal = (record: FixDepositRegister) => {
        setSelectedRecord(record);
        setShowModifyModal(true);
    };

    const openStalkerModal = (user: User) => {
        setSelectedUser(user);
        setShowStalkerModal(true);
    };

    const openRemoveModal = (record: FixDepositRegister) => {
        setSelectedRecord(record);
        setShowRemoveModal(true);
    };

    const closeModal = () => {
        setShowModifyModal(false);
        setShowRemoveModal(false);
        setShowStalkerModal(false);
        setSelectedUser(undefined);
        setSelectedRecord(undefined);
    };

    const handleStateChange = () => {
        setRecordsStateChange(!recordsStateChange);
    };

    React.useEffect(() => {
        getFixDepositRegister(menu?.daisyMenu)
            .then((response) => {
                setRecords(response);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [menu?.daisyMenu, recordsStateChange]);

    const dataRowStyling = "text-center font-bold p-3 border-2 hover:opacity-80 cursor-pointer";

    return (
        <>
            <GoToUserProfile title="Átirányítás" user={selectedUser} showModal={showStalkerModal} closeModal={closeModal} />
            <ModifyFixDepositModal title="Adatsor módosítása" group={menu?.daisyMenu} showModal={showModifyModal} closeModal={closeModal} handleStateChange={handleStateChange} row={selectedRecord} />
            <RemoveFixDepositModal title="Adatsor törlése" group={menu?.daisyMenu} showModal={showRemoveModal} closeModal={closeModal} handleStateChange={handleStateChange} row={selectedRecord} />

            <div className="w-full overflow-x-auto text-white h-full">
                <div style={{ maxHeight: 600, overflowY: 'auto' }}>
                    <table className="w-full shadow-lg text-sm border-white border-[10px]">
                        <thead className="bg-gray-800 sticky top-0">
                            <tr>
                                <th className="border p-2">ID</th>
                                <th className="border p-2">Ügyfél neve</th>
                                <th className="border p-2 bg-gray-700">Befizetett tőke (EUR)</th>
                                <th className="border p-2">Szerződés indulásának dátuma</th>
                                <th className="border p-2">Szerződés lejártának dátuma</th>
                                <th className="border p-2 bg-gray-700">Garantált hozam (/év)</th>
                                <th scope="col" className="border p-2"><span className="sr-only">Módosítás</span></th>
                                <th scope="col" className="border p-2"><span className="sr-only">Kimutatás</span></th>
                                <th scope="col" className="border p-2"><span className="sr-only">Törlés</span></th>
                            </tr>
                        </thead>
                        <tbody className="bg-dark-blue text-white">
                            {records.map((record) => (
                                <tr key={record.id} className="border even:bg-dark-blue odd:bg-light-blue hover:bg-gray-700">
                                    <td className={dataRowStyling}>{record.id}</td>
                                    <td className={dataRowStyling}>{record?.user?.name || "-"}</td>
                                    <td className={dataRowStyling} style={{ color: "#E8D788" }}>{record.invested}</td>
                                    <td className={dataRowStyling}>{record.contractStartDate ? record.contractStartDate.toString().split('T')[0] : "-"}</td>
                                    <td className={dataRowStyling}>{record.contractEndDate ? record.contractEndDate.toString().split('T')[0] : "-"}</td>
                                    <td className={dataRowStyling} style={{ color: "#E8D788" }}>{record.guaranteedReturn}%</td>

                                    {/* Módosítás gomb */}
                                    <td className={dataRowStyling}>
                                        <p onClick={() => openModifyModal(record)} className="text-cream hover:opacity-80 text-md font-bold text-center p-2 cursor-pointer">
                                            Módosítás
                                        </p>
                                    </td>

                                    {/* Kimutatás gomb */}
                                    <td className={dataRowStyling}>
                                        <p onClick={() => openStalkerModal(record.user)} className="text-indigo-500 hover:opacity-80 text-md font-bold text-center p-2 cursor-pointer">
                                            Kimutatás
                                        </p>
                                    </td>

                                    {/* Törlés gomb */}
                                    <td className={dataRowStyling}>
                                        <p onClick={() => openRemoveModal(record)} className="text-error hover:opacity-80 text-md font-bold text-center p-2 cursor-pointer">
                                            Törlés
                                        </p>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}